// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { getGatesWithUrlOverrides } from '../auth/authUtils';
import { getActiveExperimentsParametersForInitiateVerification } from '../experiments/ExperimentUtils';
import { getPreferredReferrer } from '../i18n/ReferrerUtils';
import { getRouteParams } from '../routing/getRouteParams';
import { Data } from '../signup-data/DATA';
import { getQueryParamsNoSignupData } from '../signup-data/getQueryParamsNoSignupData';
import { getValidatedCompanyDomain } from '../signup-data/getValidatedCompanyDomain';
import { getExperimentUtk } from '../store/experiments/selectors';
import { getFlatSignupDataValueMap } from '../store/signup-data/selectors';
import { getTalonValue } from '../talon/getTalonValue';
import AnonymousUsageTrackerContainer from '../tracking/AnonymousUsageTrackerContainer';
import { getSignupMode } from '../tracking/getSignupMode';
import { getImpactAdditionalParams } from '../utils/affiliateUtils';
import { screamingSnakeToCamel } from '../utils/data-structure-utils/screamingSnakeToCamel';
import { endpointForwardedUtms } from '../utm/utmHelpers';
import { getQueryParamsNoEmbedderOptions } from '../routing/getQueryParamsNoEmbedderOptions';
import { getAmplitudeEventBody } from '../hubspot-forms/getAmplitudeEventBody';
import { IdentityVerificationMethod } from '../tracking/IdentityVerificationMethod';
export const getOdysseySignupDataBody = state => {
  const userInformation = [Data.Email, Data.FirstName, Data.LastName];
  const signupData = getFlatSignupDataValueMap(state);
  return {
    odysseySignupData: Object.assign({
      experimentId: getExperimentUtk(state)
    }, Object.keys(signupData).filter(dataKey => ![...userInformation, Data.Token].includes(dataKey)).reduce((result, dataKey) => {
      const snakeDataKey = screamingSnakeToCamel(dataKey);
      result[snakeDataKey] = dataKey === Data.CompanyDomain ? getValidatedCompanyDomain(signupData[dataKey]) : signupData[dataKey];
      return result;
    }, {}))
  };
};
export const getInitiateVerificationBody = state => {
  const talon = getTalonValue();
  const signupData = getFlatSignupDataValueMap(state);
  const {
    queryParams,
    flowKey
  } = getRouteParams();
  const howUtms = endpointForwardedUtms(queryParams);
  const queryParamsWithoutSignupData = getQueryParamsNoSignupData(queryParams, signupData);
  const queryParamsNoEmbedderOptions = getQueryParamsNoEmbedderOptions(queryParamsWithoutSignupData);
  const params = Object.keys(queryParamsNoEmbedderOptions).filter(key => key !== 'gates').reduce((res, key) => Object.assign({}, res, {
    [key]: queryParamsNoEmbedderOptions[key]
  }), {});
  const activeExperimentsParameters = getActiveExperimentsParametersForInitiateVerification(state);
  const gatesOverrides = {
    gates: getGatesWithUrlOverrides([])
  };
  const chatbotIdentifier = Cookies.get('messagesUtk') ? {
    messagesUtk: Cookies.get('messagesUtk')
  } : {};
  const hasNameFieldsFilled = signupData[Data.FirstName] && signupData[Data.LastName];
  return Object.assign({
    additionalUrlParams: Object.assign({}, params, {}, howUtms, {}, getImpactAdditionalParams(), {
      preReferrer: getPreferredReferrer(),
      flowPath: flowKey,
      signupMode: getSignupMode(),
      anon: AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled
    }, chatbotIdentifier)
  }, getOdysseySignupDataBody(state), {
    email: signupData[Data.Email]
  }, hasNameFieldsFilled && {
    userInformation: {
      firstName: signupData[Data.FirstName],
      lastName: signupData[Data.LastName]
    }
  }, {
    talon,
    activeExperimentsParameters,
    gatesOverrides,
    verificationMethod: IdentityVerificationMethod.CodeVerification
  }, getAmplitudeEventBody(state));
};